import useAuth from '../hooks/useAuth';
import Header from './Header';
import Knoppie from './Knoppie';
import PayrollImage from '../../src/images/payroll.png';
import StockControl from '../../src/images/StockControl.png';
import Documents from '../../src/images/Documents.png';
import NoImage from '../../src/images/no-image.png';
import Employee from '../../src/images/employee.png';
import { MessageBox } from './MessageBox';
import { useEffect, useState, useRef } from 'react';
import {WS_URL} from '../config'
import { useUserListFetch } from '../hooks/useUserListFetch';
const Home = () => {
    
    
     // State to handle input field
    const {userState,userLoading,userError,setUserSearchValue,setUserIncludeInactive,setUserLoading,setUserTrigger} = useUserListFetch();
    const ws = useRef(null); // Store WebSocket connection persistently

    const auth = useAuth();
    const user = auth?.auth?.user;

    console.log(userState)
    // useEffect(() => {
    //     if (!user) return;

    //     ws.current = new WebSocket(`${WS_URL}?username=${user.username}`);

    //     ws.current.onopen = () => {
    //         console.log('Connected to WebSocket server');
    //         ws.current.send('Hello Server');
    //     };

    //     ws.current.onmessage = async (event) => {
    //         try {
    //             let data;
    //             if (event.data instanceof Blob) {
    //                 const text = await event.data.text();
    //                 console.log('Received:', text);
    //                 data = JSON.parse(text);
    //             } else {
    //                 console.log('Received:', event.data);
    //                 data = JSON.parse(event.data);
    //             }

    //             if (data.type === 'onlineUsers') {
    //                 setOnlineUsers(data.users);
    //             } else {
    //                 setMessages((prevMessages) => [...prevMessages, {message:data.message, sender: data.sender} || data]);
    //             }
    //         } catch (error) {
    //             console.error('Error parsing WebSocket message:', error);
    //         }
    //     };

    //     ws.current.onerror = (error) => {
    //         console.error('WebSocket Error:', error);
    //     };

    //     ws.current.onclose = (event) => {
    //         console.log('WebSocket closed by ');
            
    //     };

    //     return () => {
    //         ws.current.close(); // Cleanup WebSocket connection on unmount
    //     };
    // }, [user]);

    if (!user) {
        return <div>Loading...</div>;
    }

    const { username, userRole: access, employeeProfile } = user;

   

    return (
        <>
            <Header username={username} role={access} />
            <div>Index</div>
            <MessageBox />

            

            <Knoppie
                clickable={true}
                image={Employee}
                text={"Messages"}
                destination={`../MessageList`}
            />

            {(access === 'administrator' || access === 'manager') && (
                <>
                    <Knoppie clickable={true} image={PayrollImage} text="Payroll" destination="Payroll" />
                    <Knoppie clickable={true} image={StockControl} text="Stock Control" destination="StockControl" />
                </>
            )}

            <Knoppie
                clickable={!!employeeProfile}
                image={Employee}
                text={employeeProfile ? 'My Employee Profile' : 'Please ask the administrator to link your employee profile.'}
                destination={employeeProfile ? `../employee/${employeeProfile}` : '#'}
            />

            <Knoppie clickable={true} image={Documents} text="Documents List" destination="DocumentsList" />

            {access === 'administrator' && (
                <Knoppie clickable={true} image={NoImage} text="Users" destination="UsersList" />
            )}
        </>
    );
};

export default Home;
